import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LabelStyle = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontWeight: 600,
}));
